/**
 * Bootstrap integration for jQuery Validate
 * These defaults format errors displayed by jQuery Validate to take advantage
 * of the form error classes provided by Twitter Bootstrap
 */

$.validator.setDefaults({
    errorElement: "em",
    errorClass: "text-danger",
    errorPlacement: function(error, element) {
        // When the input is part of an input group, errors should be appended after the group
        var group = $(element).closest(".input-group");
        group.length > 0
            ? $(group).after(error)
            : $(element).after(error);
    },

    highlight: function(element, errorClass, validClass) {
        $(element).closest(".form-group").addClass("has-error");
    },
    unhighlight: function(element, errorClass, validClass) {
        $(element).closest(".form-group").removeClass("has-error");
    },
});